
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class HomeHeading extends Vue {
  @Prop() step: number | undefined;
}
